import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import "./EditProfessionaldetails.css";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const EditProfessionaldetails = ({ onSubmit, onClick }) => {
  const profession = sessionStorage.getItem("profession");
  const City = sessionStorage.getItem("selectedCity");
  const State = sessionStorage.getItem("selectedState");
  const PointofContact = sessionStorage.getItem("PointofContact");
  const HeardFrom = sessionStorage.getItem("HeardFrom");
  const heardFromother = sessionStorage.getItem("HeardFromOther");
  const [professionId, setProfessionId] = useState(profession);
  // console.log("profession caluee",professionId);

  const [selectedprofarray, setSelectedprofarray] = useState(null);
  const [selectedheardfromarray, setSelectedheardfromarray] = useState([]);
  const [heardFromId, setHeardFromId] = useState(HeardFrom);
  console.log("heardfrom value", typeof heardFromId);
  const [stateId, setStateId] = useState(State);
  const [cityId, setCityId] = useState(City);
  const [statearray, setstatearray] = useState(null);
  const [cityarray, setCityarray] = useState(null);
  const [username, setUsername] = useState(PointofContact);
  const [userarray, setUserarray] = useState(null);
  const [heardFromOther, setHeardFromOther] = useState(heardFromother);
  console.log("othervalue", heardFromOther);
  const handleInputChange = (name, value) => {
    sessionStorage.setItem(name, value);
  };

  useEffect(() => {
    setProfessionId(sessionStorage.getItem("profession") || "");
    setCityId(sessionStorage.getItem("selectedCity") || "");
    setStateId(sessionStorage.getItem("selectedState") || "");
    setUsername(sessionStorage.getItem("PointofContact") || "");
    setHeardFromId(sessionStorage.getItem("HeardFrom") || "");
    setHeardFromOther(sessionStorage.getItem("HeardFromOther") || "");
  }, []);

  const handleHeardFromChange = (value) => {
    const res = value;
    setHeardFromId(res);
    console.log("heardFromId:", heardFromId);
    console.log("option.value:", value);

    // Store the selected value in sessionStorage
    sessionStorage.setItem("HeardFrom", res);
  };
  const handlepointofcontactChange = (event) => {
    setUsername(event.target.value);
  };
  const handleProfChange = (event) => {
    setProfessionId(event.target.value);
    console.log("selected value111", event.target.value);
    // Add any additional logic you want when the value changes
  };

  const handleStateChange = (event) => {
    setStateId(event.target.value);
  };

  const handleCityChange = (event) => {
    setCityId(event.target.value);
  };

  useEffect(() => {
    const getprofessiondata = async () => {
      const nresponse = await axios.get(
        `${apiUrl}/CCE/api/v1/commonEngine/professions`
      );
      console.log("newresponse", nresponse);
      const result = nresponse.data.response;
      console.log("nwew result", result);
      const professions = result.map((profession) => ({
        value: profession.id,
        label: profession.profession_name,
      }));
      setSelectedprofarray(professions);
      const professionid = sessionStorage.getItem("profession");
      console.log("profession ids", professionid);
      // const res = professions[professionid-1]?.value;
      console.log("seelve11111111111111111", professions[professionid]?.value);
    };
    getprofessiondata();
  }, []);

  const getheardfromdata = async () => {
    const resva = await axios.get(
      `${apiUrl}/CCE/api/v1/commonEngine/heardfrom`
    );
    console.log("resva", resva);
    const result = resva.data.response;
    const heardfrom = result.map((profession) => ({
      value: profession.id,
      label: profession.heardFrom_name,
    }));
    setSelectedheardfromarray(heardfrom);
    console.log("herd from", heardfrom);
  };
  // selectedheardfromarray?.map((option) =>console.log("inside debug",option.value))
  const getstatedata = async () => {
    const resva = await axios.get(`${apiUrl}/CCE/api/v1/commonEngine/state`);
    console.log("resvastate", resva);
    const result = resva.data.response;
    console.log("resultstate", result);
    const statename = result.map((profession) => ({
      value: profession.id,
      label: profession.statename,
    }));
    setstatearray(statename);
    console.log("statearray", statename);
  };

  const handleCheck = async () => {
    const res = await axios.post(`${apiUrl}/CCE/api/v1/userEngine/users`, {
      roleId: "1,2,6",
    });
    const result = res.data.response;
    const username = result.map((profession) => ({
      value: profession.id,
      label: `${profession.firstname} ${profession.lastname}`,
    }));
    setUserarray(username);
    // console.log("asdfdfglkjdfgjkjhkjl",res);
  };
  const getCitiesdata = async () => {
    const res = await axios.get(`${apiUrl}/CCE/api/v1/commonEngine/cities`);
    console.log("citydata", res);
    const resva = res.data.response;
    const username = resva.map((profession) => ({
      value: profession.id,
      label: profession.cityname,
    }));
    setCityarray(username);
  };

  useEffect(() => {
    getheardfromdata();
    getstatedata();
    handleCheck();
    getCitiesdata();
  }, []);

  const handlesubmit = (event) => {
    event.preventDefault();
    console.log("form submitted1111");
    handleInputChange("profession", professionId);
    handleInputChange("selectedCity", cityId);
    handleInputChange("selectedState", stateId);
    handleInputChange("PointofContact", username);
    handleInputChange("HeardFrom", heardFromId);
    handleInputChange("HeardFromOther", heardFromOther); // Prevents the default form submission behavior
    onSubmit({
      professionId,
      cityId,
      stateId,
      username,
      heardFromId,
      heardFromOther,
    });
  };

  return (
    <>
      <h2>Professional Details</h2>
      <form onSubmit={handlesubmit}>
        <Box sx={{ marginTop: "12px" }}>
          <Box sx={{ minWidth: 100 }}>
            <div>
              <div style={{ textAlign: "left", marginLeft: "25px" }}>
                <label htmlFor="profession">Select Profession</label>
                {/* Other items go here */}
              </div>
              <select
                id="profession"
                value={professionId}
                onChange={handleProfChange}
                style={{ textAlign: "left", width: "90%", padding: "10px" }}
              >
                {selectedprofarray?.map((option) => (
                  <option
                    style={{ padding: "8px" }}
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </Box>
        </Box>
        <Box sx={{ marginTop: "12px" }}>
          <Box sx={{ Width: 100 }}>
            <div>
              <div style={{ textAlign: "left", marginLeft: "25px" }}>
                <label htmlFor="city">Select City</label>
              </div>

              <select
                id="city"
                value={cityId}
                onChange={handleCityChange}
                style={{ textAlign: "left", width: "90%", padding: "10px" }}
              >
                {cityarray?.map((option) => (
                  <option
                    style={{ padding: "8px" }}
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </Box>
        </Box>
        <Box sx={{ marginTop: "12px" }}>
          <Box sx={{ minWidth: 100 }}>
            <div>
              <div style={{ textAlign: "left", marginLeft: "25px" }}>
                <label htmlFor="city">Select State</label>
              </div>
              <select
                id="city"
                value={stateId}
                onChange={handleStateChange}
                style={{ textAlign: "left", width: "90%", padding: "10px" }}
              >
                {statearray?.map((option) => (
                  <option
                    style={{ padding: "8px" }}
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </Box>
        </Box>
        <Box sx={{ marginTop: "8px" }}>
          <Box sx={{ minWidth: 80 }}>
            <div>
              <div style={{ textAlign: "left", marginLeft: "25px" }}>
                <label htmlFor="contact">Select Contact Person</label>
              </div>

              <select
                id="contact"
                value={username}
                onChange={handlepointofcontactChange}
                style={{ textAlign: "left", width: "90%", padding: "10px" }}
              >
                {userarray?.map((option) => (
                  <option
                    style={{ padding: "8px" }}
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </Box>
        </Box>
        <Box>
          <Typography
            sx={{
              textAlign: "left",
              margin: "12px 0px 0px 20px",
              width: "90%",
            }}
          >
            How did you hear about us?
          </Typography>
          <div style={{ marginLeft: "10px", textAlign: "center" }}>
            <Box className="radio-container">
              {selectedheardfromarray?.map((option) => (
                <div className="radio-item" key={option.value}>
                  <div>
                    <input
                      type="radio"
                      id={`heardFrom_${option.value}`}
                      name="heardFrom"
                      value={option.value}
                      checked={heardFromId == option.value}
                      onChange={() => handleHeardFromChange(option.value)}
                      style={{ width: "15px", height: "15px" }}
                    />
                  </div>
                  <div>
                    <label htmlFor={`heardFrom_${option.value}`}>
                      {option.label}
                    </label>
                  </div>
                </div>
              ))}
            </Box>
          </div>
          <div>
            {heardFromId === 7 ? (
              <div>
                {" "}
                <TextField
                  label="Other"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  required
                  value={heardFromOther}
                  onChange={(e) => setHeardFromOther(e.target.value)}
                />
              </div>
            ) : null}
          </div>
        </Box>
        <Button sx={styles.btnprofessional} type="button" onClick={onClick}>
          Back
        </Button>
        <Button type="submit" sx={styles.btnprofessional}>
          Save
        </Button>
      </form>
    </>
  );
};

export default EditProfessionaldetails;

const styles = {
  btnprofessional: {
    margin: "10px",
    width: "100px",
    height: "40px",
    marginTop: "1em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
